import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
	getScheduleConfiguration,
	getWorkerSubType,
	getWorkerTypes,
	updateScheduleConfiguration,
} from "../../../../../store/gat-admin-slice";
import useWorkerMovementData from "./use-worker-movement-data";

const useWorkerMovementController = (locationId: number) => {
	const dispatch = useDispatch();
	const {
		scheduleConfiguration,
		scheduleConfigurationStatus,
		scheduleConfigurationError,
		updateScheduleConfigurationStatus,
		updateScheduleConfigurationError,
		workerTypes,
		workerTypesStatus,
		workerSubTypes,
		workerSubTypesStatus,
		companyId,
	} = useWorkerMovementData();

	const [isDialogOpen, setIsDialogOpen] = useState(false);

	useEffect(() => {
		if (locationId) {
			dispatch(getScheduleConfiguration(locationId));
		}
	}, [locationId, dispatch]);

	useEffect(() => {
		if (workerTypes.length === 0 && workerTypesStatus === "idle") {
			dispatch(getWorkerTypes());
		}
	}, [workerTypes, workerTypesStatus, dispatch]);

	useEffect(() => {
		if (companyId && (!workerSubTypes || workerSubTypes.length === 0) && workerSubTypesStatus === "idle") {
			dispatch(getWorkerSubType(companyId));
		}
	}, [companyId, workerSubTypes, workerSubTypesStatus, dispatch]);

	useEffect(() => {
		if (updateScheduleConfigurationStatus === "fulfilled") {
			setIsDialogOpen(false);
		}
	}, [updateScheduleConfigurationStatus]);

	const openDialog = () => {
		setIsDialogOpen(true);
	};

	const closeDialog = () => {
		setIsDialogOpen(false);
	};

	const handleSave = (updatedWorkerMovementEligibility: any) => {
		if (!scheduleConfiguration) return;

		const payload = {
			locationId,
			configurationJson: {
				...scheduleConfiguration,
				movementEligibility: updatedWorkerMovementEligibility,
			},
		};

		dispatch(updateScheduleConfiguration(payload));
	};

	return [
		{
			isDialogOpen,
			scheduleConfiguration,
			scheduleConfigurationStatus,
			scheduleConfigurationError,
			updateScheduleConfigurationStatus,
			updateScheduleConfigurationError,
			workerTypes,
			workerTypesStatus,
			workerSubTypes,
			workerSubTypesStatus,
		},
		{
			openDialog,
			closeDialog,
			handleSave,
			dispatch,
		},
	] as const;
};

export default useWorkerMovementController;
